import {Subsidiary} from '../subsidiary';

export function toString(this: Subsidiary) {
    return `Deal: ${this.id}`;
}
